import superagent from 'superagent'

export const tracksSet = tracks => ({
  type: 'TRACKS_SET',
  payload: tracks
})

export const trackCreate = track => ({
  type: 'TRACK_CREATE',
  payload: track
})

export const trackUpdate = track => ({
  type: 'TRACK_UPDATE',
  payload: track
})

export const trackDelete = id => ({
  type: 'TRACK_DELETE',
  payload: id
})

export const trackFetchRequest = () => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .get(`${__API_URI__}/measurement/get?activityId=1&measurementType=1`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          if (err.status == 401) {
            return err.status
          }
        }
        resolve(res.body)
        dispatch(tracksSet(res.body))
      })
  })
}

export const trackCreateRequest = trackObj => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .post(`${__API_URI__}/measurement/create`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(trackObj))
      .end((err, res) => {
        if (err) {
          if (err.status == 401) {
            return err.status
          }
        }
        dispatch(trackCreate(res.body))
        resolve(res.body)
      })
  })
}

export const trackUpdateRequest = trackObj => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .put(`${__API_URI__}/measurement/update`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(trackObj))
      .end((err, res) => {
        if (err) {
          if (err.status == 401) {
            return err.status
          }
        } else {
          dispatch(trackUpdate(res.body))
        }
        resolve(res.body)
      })
  })
}

export const trackDeleteRequest = id => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .delete(`${__API_URI__}/measurement/delete/${id}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          if (err.status == 401) {
            return err.status
          }
        }
        resolve(res.body)
        dispatch(trackDelete(id))
      })
  })
}
